import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import type { AgriInSubmit } from '@/components/agricultural-materials/agri-in-note-form'
import { AgriInNoteForm } from '@/components/agricultural-materials/agri-in-note-form'
import { useAuth } from '@/hooks/use-auth'
import { useCreateAgriInNote } from '@/hooks/use-agri-material-lot-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agricultural-materials/stock-in-notes/new',
)({
    component: NewAgriInNotePage,
})

function NewAgriInNotePage() {
    const { hasPermission, arePermissionsLoaded } = useAuth()
    if (arePermissionsLoaded && !hasPermission('agri_material_lots.write')) {
        return (
            <div className="p-6 text-sm text-muted-foreground">
                {m.aml_no_permission_create()}
            </div>
        )
    }
    return <NewForm />
}

function NewForm() {
    const navigate = useNavigate()
    const create = useCreateAgriInNote()

    const back = () =>
        navigate({ to: '/agricultural-materials/stock-in-notes' })

    const handleSubmit = async (
        value: AgriInSubmit,
        workflow: Parameters<
            React.ComponentProps<typeof AgriInNoteForm>['onSubmit']
        >[1],
    ) => {
        try {
            await workflow.run(
                () => create.mutateAsync(value),
                (res) => res.data?.id,
            )
            await back()
        } catch (err) {
            toast.error(
                err instanceof Error ? err.message : m.sl_new_error_create(),
            )
        }
    }

    return (
        <AgriInNoteForm
            isPending={create.isPending}
            onSubmit={handleSubmit}
            onCancel={back}
        />
    )
}
